
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick } from 'vue'
import { ToTopOutlined, RightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import { useStore, mapState, mapMutations, mapActions } from 'vuex'
import Modal from '@/views/f10/modal.vue'
// import Navatop from '../../components/navtop.vue'
import Navatop from '../../components/navtopF10.vue'

// import Navatop from "@/components/navatop.vue";
import api from '@/api/allApi'
import gsgy from '@/components/pageUs/gsgy.vue'
import zxzb from '@/components/pageUs/zxzb.vue'
import jqzysj from '@/components/pageUs/jqzysj.vue'
import dshcy from '@/components/pageUs/dshcy.vue'
import gdfx from '@/components/pageUs/gdfx.vue'
import lhbd from '@/components/pageUs/lhbd.vue'
import lhbdDetail from '@/components/pageUs/lhbdDetail.vue'
import dzjy from '@/components/pageUs/dzjy.vue'
import rzrq from '@/components/pageUs/rzrq.vue'
import xxqk from '@/components/pageUs/xxqk.vue'
import fxxg from '@/components/pageUs/fxxg.vue'
import gdrs from '@/components/pageUs/gdrs.vue'
import sdltgd from '@/components/pageUs/sdltgd.vue'
import sdgd from '@/components/pageUs/sdgd.vue'
import jgcc from '@/components/pageUs/jgcc.vue'
import sdgdcgbd from '@/components/pageUs/sdgdcgbd.vue'
import sdgdcgbdDetail from '@/components/pageUs/sdgdcgbdDetail.vue'
import jjcg from '@/components/pageUs/jjcg.vue'
import xsjj from '@/components/pageUs/xsjj.vue'
import xsjjDetail from '@/components/pageUs/xsjjDetail.vue'
import zyjs from '@/components/pageUs/zyjs.vue'
import zygcfx from '@/components/pageUs/zygcfx.vue'
import jyps from '@/components/pageUs/jyps.vue'
import gbjg from '@/components/pageUs/gbjg.vue'
import lngbbd from '@/components/pageUs/lngbbd.vue'
import yjyc from '@/components/pageUs/yjyc.vue'
import ycmx from '@/components/pageUs/ycmx.vue'
import xxzbyc from '@/components/pageUs/xxzbyc.vue'
import ybpj from '@/components/pageUs/ybpj.vue'
import gglb from '@/components/pageUs/gglb.vue'
import ggjxgrycgbd from '@/components/pageUs/ggjxgrycgbd.vue'
import ggjxgrycgbdDetail from '@/components/pageUs/ggjxgrycgbdDetail.vue'
import zyzb from '@/components/pageUs/zyzb.vue'
import dbfx from '@/components/pageUs/dbfx.vue'
import zcfzb from '@/components/pageUs/zcfzb.vue'
import lrb from '@/components/pageUs/lrb.vue'
import xjllb from '@/components/pageUs/xjllb.vue'
import bfbbb from '@/components/pageUs/bfbbb.vue'
import fhqk from '@/components/pageUs/fhqk.vue'
import lnfhrz from '@/components/pageUs/lnfhrz.vue'
import zfmx from '@/components/pageUs/zfmx.vue'
import jqzysjDetail from '@/components/pageUs/jqzysjDetail.vue'
import zdsx from '@/components/pageUs/zdsx.vue'
import dzjyDetail from '@/components/pageUs/dzjyDetail.vue'
import rzrqDetail from '@/components/pageUs/rzrqDetail.vue'
import hydw from '@/components/pageUs/hydw.vue'
import hykd from '@/components/pageUs/hykd.vue'
import pgmx from '@/components/pageUs/pgmx.vue'
import dyhd from '@/components/pageUs/dyhd.vue'
import gszx from '@/components/pageUs/gszx.vue'
import cwbg from '@/components/pageUs/cwbg.vue'
import gsggDetail from '@/components/pageUs/gsggDetail.vue'
import yjbg from '@/components/pageUs/yjbg.vue'
import tzzhd from '@/components/pageUs/tzzhd.vue'
import HydwHeadline from '@/components/HydwHeadline.vue'
import globalsets from '@/utils/globalsets'
import glccy from '@/components/pageUs/glccy.vue'
import zygd from '@/components/pageUs/zygd.vue'
import gbbd from '@/components/pageUs/gbbd.vue'
import zjzl from '@/components/pageUs/zjzl.vue'
import fchb from '@/components/pageUs/fchb.vue'
import fhtj from '@/components/pageUs/fhtj.vue'
import gsgg from '@/components/pageUs/gsgg.vue'
import ssetf from '@/components/pageUs/ssetf.vue'
import pesylttm from '@/components/pageUs/pesylttm.vue'
import pbsyllf from '@/components/pageUs/pbsyllf.vue'
import pssylttm from '@/components/pageUs/pssylttm.vue'
import cwzb from '@/components/pageUs/cwzb.vue'
import fhpx from '@/components/pageUs/fhpx.vue'
import gphg from '@/components/pageUs/gphg.vue'
import gxxg from '@/components/pageUs/gxxg.vue'
import cg from '@/components/pageUs/cg.vue'
import fh from '@/components/pageUs/fh.vue'
import cwzbnewZui from '@/components/pageUs/cwzbnewZui.vue'

export default defineComponent({
  components: {
    ToTopOutlined,
    RightOutlined,
    glccy,
    cwzbnewZui,
    fhpx,
    gxxg,
    gphg,
    cwzb,
    ssetf,
    pbsyllf,
    pssylttm,
    pesylttm,
    fhtj,
    gsgg,
    fchb,
    zjzl,
    zygd,
    gbbd,
    Navatop,
    cwbg,
    gsgy,
    zxzb,
    jqzysj,
    dshcy,
    gdfx,
    lhbd,
    lhbdDetail,
    dzjy,
    rzrq,
    xxqk,
    fxxg,
    gdrs,
    sdltgd,
    sdgd,
    jgcc,
    sdgdcgbd,
    sdgdcgbdDetail,
    jjcg,
    xsjj,
    xsjjDetail,
    zyjs,
    zygcfx,
    jyps,
    gbjg,
    lngbbd,
    yjyc,
    ycmx,
    xxzbyc,
    ybpj,
    gglb,
    ggjxgrycgbd,
    ggjxgrycgbdDetail,
    zyzb,
    dbfx,
    zcfzb,
    lrb,
    xjllb,
    bfbbb,
    fhqk,
    lnfhrz,
    zfmx,
    jqzysjDetail,
    zdsx,
    hydw,
    hykd,
    pgmx,
    dyhd,
    gszx,
    gsggDetail,
    yjbg,
    tzzhd,
    HydwHeadline,
    dzjyDetail,
    rzrqDetail,
    cg,
    fh,
    Modal // 模态框
  },
  setup(props, context) {
    const pageData: any = reactive({
      nav: [],
      cardtitleimg: require('@/assets/cardtitle_l.png'),
      key: '' + new Date().getTime(),
      target: () => document.querySelector('.wrapper'),
      isopen: true,
      theme: 'light',
      token: '',
      pageSourceData: {},
      currentsharesData: {},
      activekey: '',
      showbacktop: true,
      containerRef: () => document.querySelector('.wrapper'),
      spinning: true,
      pubDate: '', // 报告期
      modalsrc: ''
    })
    const route = useRoute()
    const store = useStore()
    const navatop: any = ref('')

    const modalvisible = ref<boolean>(false)
    const closemodal = () => {
      modalvisible.value = false
    }
    if (route.query.theme === 'dark') {
      pageData.theme = 'dark'
      pageData.cardtitleimg = require('@/assets/cardtitle_d.png')
    } else {
      pageData.theme = 'light'
      pageData.cardtitleimg = require('@/assets/cardtitle_l.png')
    }
    function getPubDate(val: any) {
      pageData.pubDate = val
    }
    function setnav(data: any) {
      nextTick(() => {
        const dom: any = document.querySelector('.wrapper')
        if (dom) {
          dom.scrollTop = 0
        }
      })
      pageData.spinning = true
      pageData.nav = data
      pageData.key = '' + new Date().getTime()
    }
    function setisopen(data: any) {
      pageData.isopen = data
    }

    // 测试
    // const obj = {
    //   OrgCode: "tc",
    //   Token: "22af8018-1e5e-4196-805c-c49e85bae26d",
    //   AppName: "tctest",
    //   AppVer: "V3.1.9",
    //   AppType: "ios",
    //   Tag: "mytag123456"
    // };
    async function gettoken() {
      // f10US
      if (route.query.token) {
        pageData.token = route.query.token

      }
      // pageData.token = await globalsets.getToken()
    }
    function getPageData(data: any) {
      console.log('getPageData', data)
      pageData.spinning = false
      pageData.pageSourceData = data
      pageData.pageSourceData.nameStr = data?.Fin?.P10?.FormerName?.length ? data?.Fin?.P10?.FormerName.join('->') : null
    }
    function currentshares(data: any) {
      pageData.currentsharesData = data
    }
    function seemore(item: any) {
      const data: any = {}
      data.key = item.target.split(',')[0]
      data.itemkey = item.target.split(',')[1]
      navatop.value.setcurrentli(data)
    }
    function seemoreDetail(item: any) {
      // const data: any = {}
      const softNameAbbr = route.query.softNameAbbr
      const path = softNameAbbr === 'jfztADV' ? 'jfzt_adv' : 'jfzt_qjb'
      if (item.key === 'jjcg') {
        let host = ''
        if (document.location.origin.indexOf('http://localhost') > -1) {
          host = 'https://test-pcstatic.9fh5.com'
        } else {
          // 如果是非PC域名，暂定https://pcstatic.sylapp.cn
          host = document.location.origin.indexOf('pcstatic') > -1 ? document.location.origin : 'https://pcstatic.sylapp.cn'
        }
        // 官网用H5弹框打开
        if (softNameAbbr === 'jfztGW') {
          const url = `${host}/${path}/eframe/index.html#/stockPopup?Inst=${route.query.code}&Exch=${route.query.market}&Name=${pageData.currentsharesData.name}&PubDate=${pageData.pubDate}&softNameAbbr=jfztGW`
          store.commit('setIframeModalInfo', {
            modalsrc: url,
            modalvisible: true,
            title: '个股主力持仓',
            width: '948px'
          })
        } else {
          window.open(
            `gw://webkitdlg?width=900;height=620;mode=0;title=个股主力持仓;allowdestroy=1;FixTab=1;url=${host}/${path}/eframe/index.html#/stockPopup?Inst=${route.query.code}&Exch=${route.query.market}&Name=${pageData.currentsharesData.name}&PubDate=${pageData.pubDate}`
          )
        }
        return
      }
      let param = ''
      let param0: any = null
      let param1: any = null
      switch (item.key) {
        case 'lhbd':
          param = '个股龙虎榜详情'
          break
        case 'lhbdDetail':
          param = '个股龙虎榜详情'
          break
        case 'dzjy':
          param = '个股大宗交易'
          break
        case 'dzjyDetail':
          param = '个股大宗交易'
          break
        case 'rzrq':
          param = '融资融券个股详情'
          break
        case 'rzrqDetail':
          param = '融资融券个股详情'
          break
        case 'tzzhd':
          param = '问董秘'
          break
        case 'ggjxgrycgbd':
          param = '个股高管增持'
          param0 = route.query.market
          param1 = route.query.code
          break
        case 'ggjxgrycgbdDetail':
          param = '个股高管增持'
          param0 = route.query.market
          param1 = route.query.code
          break
      }
      if (item.key === 'tzzhd') {
        const url = `gw://funccall?funcname=OnFireCommand;Command=CmdStyle.WDM;param=<params><web_inner_url>${origin}/operationmanual/index.html#/asking?market=${route.query.market}&code=${route.query.code}</web_inner_url><stock_list><list_code>问董秘</list_code></stock_list></params>`
        window.open(url)
      } else {
        let url = `gw://funccall?funcname=OnDoCommand;param=${param}`
        if (param0) {
          url += param0 ? `;param0=${param0}` : ''
        }
        if (param1) {
          url += param1 ? `;param1=${param1}` : ''
        }
        window.open(url)
      }
    }

    let scrollTop = 0
    const scrollEndTop = 0
    let timer: any = null
    function scrollhashwrapper(event: any) {
      pageData.showbacktop = true
      clearTimeout(timer)
      timer = setTimeout(showtop, 3000)
      scrollTop = event.target.scrollTop
    }
    function showtop() {
      pageData.showbacktop = false
    }
    gettoken()
    return {
      ...toRefs(pageData),
      setnav,
      setisopen,
      gettoken,
      getPageData,
      seemore,
      navatop,
      seemoreDetail,
      scrollhashwrapper,
      currentshares,
      getPubDate,
      modalvisible,
      closemodal
    }
  }
})
